import * as React from "react";
import { Text, StyleSheet, View, Image, TouchableOpacity, Platform, Linking } from "react-native";
import { FontSize, Color, FontFamily, Border, Padding, LocalizedString } from "@common";
import { useSelector, useDispatch } from 'react-redux';
import { CheckBox } from '@rneui/themed';
import { DateTime } from 'luxon';
import { createAction } from '@utils';


const openExternalLink = (url) => {
  if (Platform.OS === 'web') {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    Linking.openURL(url).catch(() => {});
  }
};

const INSURANCE_URLS = {
  privacy: 'https://myetrade.com.my/insurance/privacy.html',
  pds: 'https://myetrade.com.my/insurance/pds.pdf',
  faq: 'https://myetrade.com.my/insurance/faq.html',
};


const TicketDetailsSection = ({selectedTrip,fromSelectedStation,toSelectedStation
  ,seatString,selectedDate,contactNo,contactId,contactEmail,showContactInfo,shouldShowInsuranceCheckBox, includeInsurance, toggleCheckbox, insuranceFee}) => {
    const language = useSelector((state) => state.config.language);
    const dispatch = useDispatch();
    const isDesktop = useSelector((state) => state.member.isDesktopWeb);
    const insuranceConsentGiven = useSelector((state) => state.trip.insuranceConsentGiven);
    const showInsurance = shouldShowInsuranceCheckBox && insuranceFee > 0;

  return (
    <View style={styles.frameParent}>
     
      <View style={[styles.groupParent, styles.parentSpaceBlock]}>
        <Image
          style={styles.frameChild}
          resizeMode="cover"
          source={require("../assets/group-511.png")}
        />
        <Text style={[styles.coachJasaPelangiContainer, styles.fromToSeatTypo]}>
          <Text style={styles.coach}>{LocalizedString.coachName}</Text>
          <Text style={styles.jasaPelangi}>{selectedTrip && selectedTrip.brandName}{`\n`}</Text>
          <Text style={styles.coach}>{LocalizedString.travelTime}</Text>
          <Text style={styles.jasaPelangi}>{selectedDate && DateTime.fromFormat(selectedDate, "yyyy-MM-dd").setLocale(language).toFormat('dd/MM/yyyy, EEE').toUpperCase()} {selectedTrip && selectedTrip.time}</Text>
        </Text>
      </View>
      <View style={styles.detailBox}>
        <View
          style={[styles.fromToSeatContactNoIcParent, styles.childSpaceBlock]}>
          <Text style={[styles.fromToSeat, styles.fromToSeatTypo]}>{`${LocalizedString.fromC}:`}</Text>
          <Text
            style={[styles.kprKamparLar, styles.fromToSeatTypo]}
          >{fromSelectedStation.stationName}</Text>
        </View>
        <View
          style={[styles.fromToSeatContactNoIcParent, styles.childSpaceBlock]}>
          <Text style={[styles.fromToSeat, styles.fromToSeatTypo]}>{`${LocalizedString.toC}:`}</Text>
          <Text
            style={[styles.kprKamparLar, styles.fromToSeatTypo]}
          >{toSelectedStation.stationName}</Text>
        </View>
        <View
          style={[styles.fromToSeatContactNoIcParent, styles.childSpaceBlock]}>
          <Text style={[styles.fromToSeat, styles.fromToSeatTypo]}>{`${LocalizedString.seat}`}</Text>
          <Text
            style={[styles.kprKamparLar, styles.fromToSeatTypo]}
          >{seatString}</Text>
        </View>
        { showContactInfo && <View
          style={[styles.fromToSeatContactNoIcParent, styles.childSpaceBlock]}>
          <Text style={[styles.fromToSeat, styles.fromToSeatTypo]}>{LocalizedString.contactNo}</Text>
          <Text
            style={[styles.kprKamparLar, styles.fromToSeatTypo]}
          >{contactNo}</Text>
        </View>}
        { showContactInfo && <View
          style={[styles.fromToSeatContactNoIcParent, styles.childSpaceBlock]}>
          <Text style={[styles.fromToSeat, styles.fromToSeatTypo]}>{LocalizedString.finalIcPassportNumber}</Text>
          <View style={[styles.fromToSeatTypo, styles.fromToSeatTypoMargin, styles.textBottom]}>
            <Text
              style={styles.kprKamparLarCombined}
            >{contactId}</Text>
          </View>
        </View>}
        { showContactInfo && contactEmail && <View
          style={[styles.fromToSeatContactNoIcParent, styles.childSpaceBlock]}>
          <Text style={[styles.fromToSeat, styles.fromToSeatTypo]}>{LocalizedString.finalContactEmail}</Text>
          <View style={[styles.fromToSeatTypo, styles.fromToSeatTypoMargin, styles.textBottom]}>
            <Text
              style={styles.kprKamparLarCombined}
            >{contactEmail}</Text>
          </View>
        </View> }
      </View>
      {showInsurance && (
        <View style={[styles.insuranceSection, !isDesktop && styles.insuranceSectionMobile]}>
          <CheckBox
            size={20}
            checkedIcon="dot-circle-o"
            uncheckedIcon="circle-o"
            title={LocalizedString.formatString(LocalizedString.premiumPackageOption, {price: insuranceFee})}
            checked={includeInsurance}
            onPress={() => { if (!includeInsurance && toggleCheckbox) toggleCheckbox(); }}
            containerStyle={styles.radioContainer}
            textStyle={styles.radioText}
          />
          {includeInsurance && (
            <View style={[styles.consentBlock, !isDesktop && styles.consentBlockMobile]}>
              <CheckBox
                size={18}
                title={LocalizedString.insuranceConsentIntro}
                checked={insuranceConsentGiven}
                onPress={() => dispatch(createAction('trip/setInsuranceConsentGiven')(!insuranceConsentGiven))}
                containerStyle={styles.consentCheckboxContainer}
                textStyle={styles.consentIntroText}
              />
              <View style={[styles.consentBullets, !isDesktop && styles.consentBulletsMobile]}>
                <Text style={styles.consentBulletText}>{"○ " + LocalizedString.insuranceConsentAge}</Text>
                <Text style={styles.consentBulletText}>{"○ " + LocalizedString.insuranceConsentData}</Text>
                <Text style={styles.consentBulletText}>
                  {"○ "}
                  {LocalizedString.formatString(LocalizedString.insuranceConsentReview, {
                    privacyLink: <Text style={styles.consentLink} onPress={() => openExternalLink(INSURANCE_URLS.privacy)}>{LocalizedString.privacyNoticeLink}</Text>,
                    pdsLink: <Text style={styles.consentLink} onPress={() => openExternalLink(INSURANCE_URLS.pds)}>{LocalizedString.pdsLink}</Text>,
                    faqLink: <Text style={styles.consentLink} onPress={() => openExternalLink(INSURANCE_URLS.faq)}>{LocalizedString.faqInsuranceLink}</Text>,
                  })}
                </Text>
                <Text style={styles.consentBulletText}>{"○ " + LocalizedString.insuranceConsentPrecedence}</Text>
              </View>
            </View>
          )}
          <CheckBox
            size={20}
            checkedIcon="dot-circle-o"
            uncheckedIcon="circle-o"
            title={LocalizedString.noInsuranceOption}
            checked={!includeInsurance}
            onPress={() => { if (includeInsurance && toggleCheckbox) toggleCheckbox(); }}
            containerStyle={styles.radioContainer}
            textStyle={styles.radioText}
          />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  detailBox: {
    marginTop: 21,
    paddingLeft: 10,
    paddingRight: 10,
  },
  parentSpaceBlock: {
    marginTop: 21,
    flexDirection: "row",
  },
  childSpaceBlock: {
    flexDirection: "row",
  },
  fromToSeatTypo: {
    fontSize: FontSize.size_sm,
    textAlign: "left",
    lineHeight: 24,
    //width: '100%',
    flex: 1,
  },
  fromToSeatTypoMargin: {
    marginLeft: 5,
  },
  textBottom: {
    justifyContent: 'flex-end',
  },
  ticketDetails: {
    fontSize: FontSize.size_xl,
    color: Color.steelblue_100,
    width: 203,
    textAlign: "left",
    lineHeight: 24,
    fontFamily: FontFamily.interBold,
    fontWeight: "700",
  },
  ticketDetailsWrapper: {
    width: 290,
    flexDirection: "row",
    alignItems: "center",
  },
  frameChild: {
    width: 38,
    height: 38,
  },
  coach: {
    color: Color.black,
  },
  jasaPelangi: {
    color: Color.deeppink,
  },
  coachJasaPelangiContainer: {
    marginLeft: 10,
    fontFamily: FontFamily.interBold,
    fontWeight: "700",
    fontSize: FontSize.size_sm,
  },
  groupParent: {
    justifyContent: "center",
    alignItems: "center",
  },
  fromToSeat: {
    color: Color.black,
    fontFamily: FontFamily.interBold,
    fontWeight: "700",
    fontSize: FontSize.size_sm,
  },
  kprKamparLar: {
    fontFamily: FontFamily.interRegular,
    marginLeft: 5,
    color: Color.black,
  },
  kprKamparLarCombined: {
    fontFamily: FontFamily.interRegular,
    color: Color.black,
    fontSize: FontSize.size_sm,
    textAlign: "left",
    lineHeight: 24,
  },
  fromToSeatContactNoIcParent: {
    minWidth: 295,
    //width: 295,
  },
  frameParent: {
    borderRadius: Border.br_base,
    backgroundColor: Color.white,
    shadowColor: "rgba(89, 27, 27, 0.05)",
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowRadius: 10,
    elevation: 10,
    shadowOpacity: 1,
    //width: 330,
    paddingTop: Padding.p_base,
    paddingBottom: Padding.p_5xl,
    paddingLeft: 5,
    paddingRight: 5,
    alignItems: "center",
  },
  insuranceSection: {
    width: '100%',
    paddingHorizontal: 5,
    marginTop: 10,
  },
  radioContainer: {
    backgroundColor: 'transparent',
    borderWidth: 0,
    paddingVertical: 4,
    paddingHorizontal: 5,
    marginLeft: 0,
    marginRight: 0,
  },
  radioText: {
    fontSize: FontSize.size_sm,
    fontFamily: FontFamily.interRegular,
    fontWeight: 'normal',
    color: Color.black,
  },
  consentBlock: {
    marginTop: 8,
    paddingHorizontal: 10,
  },
  consentCheckboxContainer: {
    backgroundColor: 'transparent',
    borderWidth: 0,
    paddingVertical: 2,
    paddingHorizontal: 0,
    marginLeft: 0,
    marginRight: 0,
  },
  consentIntroText: {
    fontSize: FontSize.size_xs,
    fontFamily: FontFamily.interMedium,
    fontWeight: '500',
    color: Color.black,
  },
  consentBullets: {
    paddingLeft: 30,
  },
  consentBulletText: {
    fontSize: FontSize.size_xs,
    fontFamily: FontFamily.interRegular,
    color: Color.black,
    lineHeight: 18,
    marginTop: 4,
  },
  consentLink: {
    color: Color.steelblue_200,
    textDecorationLine: 'underline',
  },
  insuranceSectionMobile: {
    paddingHorizontal: 10,
    marginTop: 16,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: '#e4e7eb',
  },
  consentBlockMobile: {
    marginTop: 12,
    paddingVertical: 10,
    backgroundColor: '#f9fbfa',
    borderRadius: 8,
  },
  consentBulletsMobile: {
    paddingLeft: 24,
  },
});

export default TicketDetailsSection;
